import React from 'react';

export function AIBadge({ children = 'Generado por IA' }) {
    return <span className="ai-badge" data-testid="ai-badge">{children}</span>;
}

export function StatusBadge({ status }) {
    const map = {
        pending: { label: 'Pendiente', cls: 'border-gray-400 text-gray-700 bg-gray-50' },
        assigned: { label: 'Asignada', cls: 'border-[#002FA7] text-[#002FA7] bg-blue-50' },
        in_progress: { label: 'En auditoría', cls: 'border-[#FFC107] text-yellow-800 bg-yellow-50' },
        in_review: { label: 'En revisión', cls: 'border-[#0A0A0A] text-[#0A0A0A] bg-gray-100' },
        approved: { label: 'Aprobada', cls: 'border-[#00875A] text-[#00875A] bg-green-50' },
        rejected: { label: 'No aprobada', cls: 'border-[#E53935] text-[#E53935] bg-red-50' },
    };
    const s = map[status] || { label: status, cls: 'border-gray-300 text-gray-700' };
    return (
        <span className={`inline-block text-[10px] uppercase tracking-[0.18em] font-semibold border px-2 py-1 ${s.cls}`}>
            {s.label}
        </span>
    );
}

export function PageHeader({ title, subtitle, children, accent = '#111111' }) {
    return (
        <div className="border-b border-gray-200 pb-6 mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
                <div className="label-xs mb-2" style={{ color: accent }}>{subtitle || ''}</div>
                <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
            </div>
            {children && <div className="flex flex-wrap gap-2">{children}</div>}
        </div>
    );
}

export function StatCard({ label, value, accent = '#111111', testId }) {
    return (
        <div className="border border-gray-200 p-6 bg-white" data-testid={testId}>
            <div className="label-xs mb-2">{label}</div>
            <div className="font-display text-3xl font-bold" style={{ color: accent }}>{value}</div>
        </div>
    );
}
